import React from "react";
import swal from "sweetalert";
import PromotionsService, { PromotionInterface } from "../services/promotions_service";
import Page from "./page";
import Image from "../assets/Camping-cuate-min.png";
import Swal from "sweetalert2";
import getCode from "../services/utils";
import firebase from 'firebase/app';

interface state {
    promotions: firebase.firestore.QueryDocumentSnapshot[],
    tempPromotions: firebase.firestore.QueryDocumentSnapshot[],
    isLoading: boolean,
}
class PromotionCode extends React.Component {

    state: state = {
        promotions: [],
        tempPromotions: [],
        isLoading: true,
    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        swal("Cargando");
        await new PromotionsService().getPromotions().then(response => {
            this.setState({
                promotions: response.docs,
                tempPromotions: response.docs,
                isLoading: false,
            });
            swal.close();
        });
    }


    async deletePromotion(promotionId: string) {
        const response = await swal({
            text: "¿Deseas elimnar la promocion " + promotionId + "?",
            buttons: [
                "Si, Eliminar",
                "No, Cerrar"
            ]
        })

        if (response == null) {
            Swal.showLoading();
            await new PromotionsService().deletePromotion(promotionId);
            await this.getData();
            Swal.hideLoading();
        }
    }

    renderContent(): JSX.Element {

        if (this.state.isLoading) {
            return (<div></div>);
        } else if (this.state.promotions.length == 0) {
            return (
                <div style={{ textAlign: "center", }}>
                    <h1 className="title">No hay Codigos promocionales</h1>
                    <img src={Image} alt="asdaca3q" style={{ height: "65vh" }} />
                </div>
            );
        }

        return (
            <div style={{ width: "100%" }}>
                {
                    this.state.promotions.map((element) => {
                        const promotion = element.data() as PromotionInterface;
                        const createdAt = ((promotion.createdAt as any) as firebase.firestore.Timestamp).toDate();


                        const renderTaked = () => {
                            if (!promotion.isSelected) {
                                return (<></>);
                            }

                            const takedAt = ((promotion.takedAt as any) as firebase.firestore.Timestamp).toDate();


                            return (
                                <>
                                    <small>Tomado: {takedAt.toISOString()}</small>
                                    <strong>Por: {promotion.takedName}</strong>
                                </>
                            );
                        }

                        return (
                            <div className="card promotion-card-child" style={{ padding: 15, width: "100%" }}>
                                <div className="content" style={{ display: "flex", flexDirection: "column", }}>
                                    <div className="container-state">
                                        <div className={"container-state-promotion " + (promotion.isSelected ? "promotion-is-selected" : "promotion-no-selected")} />
                                        <h5>{promotion.promotionCode} (${promotion.value}) </h5>
                                    </div>
                                    <small>Creado: {createdAt.toISOString()}</small>
                                    {renderTaked()}
                                </div>

                                {
                                    promotion.isSelected == false && (
                                        <button className="button is-danger" onClick={() => this.deletePromotion(promotion.promotionCode)}>
                                            <span className="icon">
                                                <i className="fas fa-trash"></i>
                                            </span>
                                        </button>
                                    )
                                }
                            </div>
                        );
                    })
                }
            </div>
        );
    }

    async handleTap() {
        const code = getCode();
        const response = await swal({
            title: "Crear un Codigo",
            text: "¿Quieres crear un codigo de promocion?",
            buttons: [
                "Si, Crear",
                "No, Cerrar",
            ]
        });

        if (response == null) {

            const value = await Swal.fire<string>({
                text: "Por valor de:",
                title: "Este valos debe ser solo NUMERICO: 700, 130, 80, 230",
                input: "number",
            });
            swal.close();

            if(!!value){
                Swal.showLoading();
    
                new PromotionsService().createPromotion({
                    createdAt: new Date(),
                    createdBy: "admin",
                    promotionCode: code,
                    isSelected: false,
                    value: parseInt(value.value),
                    isUsed: false,
                }).then(async () => {
                    await this.getData();
                    Swal.hideLoading();
                    Swal.fire({
                        title: "Codigo Generado",
                        text: code,
                    });
                })
            }
        }
    }

    handleChange(text: string){
        const results = [];

        if(text.length == 0){
            this.setState({
                promotions: this.state.tempPromotions,
            })
        }

        for(const element of this.state.tempPromotions){
            if(element.id.includes(text.toUpperCase())){
                results.push(element);
            }
        }

        this.setState({
            promotions: results,
        })
    }

    render() {
        return (
            <Page>
                <div style={{
                    width: "100%",
                    padding: 15,
                    justifyContent: "space-between",
                    display: "flex",
                }}>
                    <input type="text" className="input" placeholder="Buscar por Codigo" onChange={(e)=> this.handleChange(e.target.value)}/>

                    <button className="button is-primary is-light" onClick={() => this.handleTap()}>
                        Crear Codigos de Promocion
                    </button>
                </div>
                <div style={{ padding: 15, display: "flex", justifyContent: "center", alignItems: "center" }}>
                    {this.renderContent()}
                </div>
            </Page>
        );
    }
}


export default PromotionCode;